export type StoryTypeKey =
  | 'Vision'
  | 'Culture'
  | 'Adversity'
  | 'EnergyMomentum'
  | 'OriginPurpose'
  | 'Transformation'
  | 'Team'
  | 'FailureLearning'
  | 'Impact'
  | 'Legacy';

export const StoryType: Record<StoryTypeKey, Stories.StoryType> = {
  Vision: 'Vision',
  Culture: 'Culture',
  Adversity: 'Adversity',
  EnergyMomentum: 'Energy / Momentum',
  OriginPurpose: 'Origin / Purpose',
  Transformation: 'Transformation',
  Team: 'Team',
  FailureLearning: 'Failure / Learning',
  Impact: 'Impact',
  Legacy: 'Legacy',
};

export const StoryTypeDescriptions: Record<StoryTypeKey, string> = {
  Vision: 'To paint a compelling picture of the future and rally people toward it.',
  Culture: 'To reinforce values, behaviors, and shared identity.',
  Adversity: 'To show resilience, honesty, and leadership through challenge.',
  EnergyMomentum: 'To inspire urgency, fire up teams, and create forward motion.',
  OriginPurpose: 'To ground leadership in personal or organizational “why.”',
  Transformation: 'To show growth, a breakthrough, or a pivotal shift—personal or collective.',
  Team: 'To highlight the power of others, support, and shared effort.',
  FailureLearning: 'To show humility, vulnerability, and the lessons that shaped leadership.',
  Impact: 'To humanize the mission through real-world results or relationships.',
  Legacy: 'To express long-term thinking, contribution, and what will be left behind.',
};

export const STORY_TYPES = Object.values(StoryType);
